import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

//
import PageTop from "../../sections/PageTop";
import DoctorInfoSection from "./sections/DoctorInfoSection";
import AboutClinicForm from "../aboutClinic/sections/AboutClinicForm";
import Location from "../../sections/Location";
import DOCTORLIST from "../../assets/data/doctor-list";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "footerAboutDoctor",
    to: "/about/doctor",
  },
  {
    id: uuidv4(),
    title: "doctorTitle",
  },
];

export default function DoctorSingle() {
  const { t } = useTranslation();
  const params = useParams();

  const DOCTOROBJ = DOCTORLIST.find((item) => item.id === +params.id);
  linkChain[2].title = DOCTOROBJ.name;

  return (
    <StyledDoctorSingle>
      <PageTop title={t("doctorSingleTitle")} linkList={linkChain} />
      <DoctorInfoSection doctor={DOCTOROBJ} />
      <AboutClinicForm />
      <Location />
    </StyledDoctorSingle>
  );
}

const StyledDoctorSingle = styled.main``;
